import { AccordionMenu } from '../../../ui/accordion-menu/accordion-menu'
import { useActionCompletedAccordion } from './use-action-completed-accordion'

export const ActionCompletedAccordion = () => {
  const { accordionMenuData, isFetchingTaskData, expandedMenuNames } = useActionCompletedAccordion()

  return (
    <AccordionMenu
      menuData={accordionMenuData}
      isFetchingData={isFetchingTaskData}
      expandedMenuNames={expandedMenuNames}
    />
  )
}
